export default __webpack_public_path__ + "static/director-introduction-0cfe9179033ffe8e399a21b5ab1e4715.jpg";